import appStore from 'store'
import api from './api'

const store = {
  namespaced: true,
  state: {
    paramsTime: {
      startTime: '',
      endTime: '',
    },
    oneEchertsData: [],
    twoEchertsData: [],
    threeEchertsData: [],
    tradeStatisticTotal: {
      date: null,
      registerCount: 0,
      firstDepositNum: 0,
      positionUidCount: 0,
      positionCount: 0,
      channelCount: null,
      totalFee: 0,
      positionProfit: 0,
      totalProfit: null,
      depositAmount: 0,
      withdrawAmount: 0,
      totalDeposit: 0,
      userBalance: 0,
      feeDay: 0,
      profitWeek: 0,
      netProfit: 0,
      ptprofit: null,
      personalProfit: null,
      groupProfit: null,
      realProfit: null,
      withdrawFee: 0,
      tradeUserCount: 0,
      highCountFee: 0,
      shortLineFee: 0,
    },
    fundList: [],
    fundTotal: 0,
    fundDetailList: [],
    fundDetailTotal: 0,
    symbolList: [],
  },

  mutations: {
    setParamsTime(state, payload) {
      state.paramsTime = payload
    },
    setOneEchertsData(state, payload) {
      state.oneEchertsData = payload
    },
    setTwoEchertsData(state, payload) {
      state.twoEchertsData = payload
    },
    setThreeEchertsData(state, payload) {
      state.threeEchertsData = payload
    },
    seTtradeStatisticTotal(state, payload) {
      state.tradeStatisticTotal = payload
    },
    setFundList(state, payload) {
      state.fundList = payload.items
      state.fundTotal = payload.total
    },
    setFundDetailList(state, payload) {
      state.fundDetailList = payload.items
      state.fundDetailTotal = payload.total
    },
    setSymbolList(state, payload) {
      state.symbolList = payload
    },
  },
  actions: {
    fetchTradeStatisticTotal({ commit }, data) {
      api.getTradeStatisticTotal(data).then((res) => {
        if (res.code == 0) {
          commit('seTtradeStatisticTotal', res.data)
        }
      })
    },
    fetchFund({ commit }, data) {
      api.getFund(data).then((res) => {
        if (res.code == 0) {
          commit('setFundList', res.data)
        }
      })
    },
    fetchFundDetail({ commit }, data) {
      api.getFundDetail(data).then((res) => {
        if (res.code == 0) {
          commit('setFundDetailList', res.data)
        }
      })
    },
    getSymbolList({ commit }, data) {
      api.getSymbolList(data).then((res) => {
        if (res.code == 0) {
          commit('setSymbolList', res.data)
        }
      })
    },
  },
}

appStore.registerModule('transactionStatistics', store)
